import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-fire-line text-lg text-white"></i>
                </div>
                <span className="text-lg font-bold font-heading text-white whitespace-nowrap">
                  黑料不打烊
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                全天候追踪娱乐圈最新黑料、明星丑闻与幕后真相。带你第一时间掌握圈内动态，不错过任何热点大瓜。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="#footer-categories" className="text-white no-underline">内容分类</a>
              </h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="#footer-links" className="text-white no-underline">快捷链接</a>
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors" rel="nofollow">
                    用户协议
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors" rel="nofollow">
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="#footer-contact" className="text-white no-underline">联系我们</a>
              </h4>
              <ul className="space-y-2 text-sm text-background-400">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-base"></i>
                  <span>contact@heiliaobudaying.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-base"></i>
                  <span>北京市朝阳区</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 黑料不打烊 版权所有 | 本站内容仅供娱乐，请勿过度解读
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors" aria-label="抖音" rel="nofollow">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}